import moment from 'moment';
import { Trans } from 'react-i18next';
import { DATE_FORMAT_DD_MMM, DATE_FORMAT_DD_MMM_YYYY } from '@/helpers/common';
import { MyLink } from '../MyLink';
import { APP_LINKS } from '@/helpers/links';
import { prettyFloatMoney } from '@/helpers/utils';
import { CONTACT_EMAIL } from '@/helpers/constants';
import { canChangeUntil } from '@/helpers/date';

export const NOTIFICATIONS = t => ({
  loan_disbursements_starts: end_date => idx => (
    <li key={idx}>
      {t('notification.loan_disbursements_starts', {
        date: `${moment(end_date).add(1, 'day').format(DATE_FORMAT_DD_MMM).replace('.', '')}, 00:00 GMT`,
      })}
    </li>
  ),
  you_can_change_fundraising_settings: end_date => idx => (
    <li key={idx}>
      {t('notification.you_can_change_fundraising_settings', {
        date: `${moment(end_date).format(DATE_FORMAT_DD_MMM).replace('.', '')}, 23:59 GMT`,
      })}
    </li>
  ),
  your_loan_successfully_completed: raised => idx => (
    <li key={idx}>
      <Trans
        ns="common"
        i18nKey="notification.your_loan_successfully_completed"
        values={{
          raised: prettyFloatMoney(raised),
        }}
        components={{
          Link: <MyLink href={APP_LINKS.loans} className="c-grey" />,
        }}
      />
    </li>
  ),
  origination_fee_charged: disbursment_fee => idx => (
    <li key={idx}>
      <Trans
        ns="common"
        i18nKey="notification.fee_of_charged"
        values={{
          fee: prettyFloatMoney(disbursment_fee),
        }}
        components={{
          Link: <MyLink href={APP_LINKS.activity} className="c-grey" />,
        }}
      />
    </li>
  ),
  not_enough_investor_to_fund: () => idx => (
    <li key={idx}>
      <Trans
        ns="common"
        i18nKey="notification.there_wasnt_enough_investor_to_fund"
        values={{ email: CONTACT_EMAIL }}
        components={{
          Link: (
            <MyLink
              className="email"
              isExternal
              newWindow={false}
              href={`mailto:${CONTACT_EMAIL}`}
            />
          ),
        }}
      />
    </li>
  ),
  next_montly_repayment: (repayment, deadline) => idx => (
    <li key={idx}>
      <Trans
        ns="common"
        i18nKey="notification.your_next_monthly_repayment"
        values={{
          repayment,
          deadline: moment(deadline).format(DATE_FORMAT_DD_MMM_YYYY).replace('.', ''),
        }}
        components={{
          Link: <MyLink href={APP_LINKS.nextPayment} className="c-grey" />,
        }}
      />
    </li>
  ),
  round_results_being_processed: () => idx => (
    <li key={idx}>{t('notification.the_results_being_processed')}</li>
  ),
  set_fundraising_goal_until: start_date => idx => (
    <li key={idx}>
      {t('notification.set_fundraising_goal', { date: canChangeUntil(start_date) })}
    </li>
  ),
  verify_phone: () => idx => (
    <li key={idx}>
      <Trans
        ns="common"
        i18nKey="notification.verify_your_phone"
        components={{
          Link: <MyLink href={`${APP_LINKS.profile}#phone`} className="c-grey" />,
        }}
      />
    </li>
  ),
  bank_accounts_available_to_verified_users: () => idx => (
    <li key={idx}>
      <Trans
        ns="common"
        i18nKey="notification.bank_accounts_available_to_verified_users"
        components={{
          Link: <MyLink href={APP_LINKS.profile} className="c-grey underline" />,
        }}
      />
    </li>
  ),
});
